import './StyleGuide.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell,faUsers, faHouse, faArrowRightFromBracket, faComments, faCircleUser, faGear, faClock} from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import React from 'react'


function LayoutGuide() {

  return (
    <div id="elements">
        <h2 className="style_header">Layout and Inline Help</h2>
        <div className='layout'>
            <div className='medium'> Our application uses a series of logos and layouts.</div>
            <p className='medium'> We use logos as a signifier for navigation. All, but the clock, are positioned in the vertical sidebar in the application.</p>
            <p className='medium'> In mobile view, this sidebar gets horizontally transformed to the bottom of the screen. </p>
            <div className='medium'>View the main ones below: </div>
            <div className="icon" >
                <div className="icon_div">
                    <FontAwesomeIcon icon={faHouse} />
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={faCircleUser} />
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={faBell} />
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={faComments}/>
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={faUsers} />
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={faGear} />
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={ faArrowRightFromBracket } />
                </div>
                <div className="icon_div">
                    <FontAwesomeIcon icon={ faClock }/>
                </div>
            </div>

            <br /><br />
        <div className='medium'> Additionally, we use different designs of buttons. They should be between 32-35 pixels high so users can clearly see them.
          <br />
        </div>
        <p className='medium'>View examples below:</p>
          
        <div className = "sg-buttons-group">
          <button type="button" className="reset-button">Button One</button>
          <button type="button" className="sign_button">Button Two</button>
          <button type="button" className="avatarSection_description_buttons_button">Button Three</button>
        </div>
        <br />

          <p className='medium'>The first button will commonly be seen in the log-in and register boxes. </p>
          <p className='medium'>The second button design will be seen in the top navigation bar of the main pages.</p>
          <p className='medium'>The third button design will be seen in areas that are complemented by the color. This can be seen on the edit profile page and as filters on the home page.</p>

          <div className='medium'>
            Our application uses input boxes often (registering, signing in, editing profile, etc.). <br />
            <br />
            Input boxes we use will have a drop shadow: <br /> <br />
            Filter: drop-shadow(0.3em 0.3em 0.35em rgba(0, 0, 0, 0.5)) <br />
            Rounded borders <br />
            Border-radius: 1rem; <br />
            Background-color: white (#ffff) <br />
            <br />
            Input Fields General Style: <br /> <br />
            Background-color: Light grey (#fafafa) <br />
            Border-color: Medium grey (#cecece) <br />
            Text-color: black (#fff) <br />
            Soft border edges <br />
            border: 2px solid #cecece; <br />
            <br /> 
            When cursor is hovering input field and when input field is selected: <br /> <br />
            Background-color: Light Green (#f6fff8) <br />
            Border-color: Green (#03a572) <br />
            Text-color: Dark green (#2d6a4f) <br />
          </div>

            <br /> <br /> 

            <br />
            <div className="rg-input-wrapper">
                    <label htmlFor="ex-input" className="form-input-label">Label</label>
                    <input type="text" required="true" name="ex-input" className="rg-input-text" placeholder="Placeholder"></input>
                </div>
          <br /><div className='medium'> Sometimes input boxes will have placeholder text give users further detail on the input requirements.</div>
          <br /><div className='medium'> Fields are typically given labels with what the expected input type is on the input field's border. </div>
      </div>
  </div>
  )
}

export default LayoutGuide